import styled from 'styled-components';

export const Container = styled.div`
    padding: 20px 0px 0px 0px;
    margin: 0px;
    width: 100%;
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
